$ = require('jquery');

const toggleAccordion = (el) => {
	
	const btn = el.find('.accordion__header');
	const panel = el.find('.accordion__panel');
	if (panel) {
		el.toggleClass('open');
		slideToggle(panel[0], btn[0]);
	}
}

const toggleAttribute = (el, attr) => {
	el.getAttribute(attr) === "true"
		? el.setAttribute(attr, "false")
		: el.setAttribute(attr, "true");
}

const slideToggle = (content, button) => {
	if (!content.classList.contains('active')) {
		content.classList.add('active');
		content.style.height = 'auto';

		let height = content.clientHeight + "px";

		content.style.height = '0px';
		if (button) toggleAttribute(button, 'aria-expanded');

		setTimeout(function () {
			content.style.height = height;
		}, 100);
	} else {
		content.style.height = '0px';

		content.addEventListener('transitionend', () => {
			content.classList.remove('active');
			button.setAttribute('aria-expanded', false)
		}, { once: true });
	}
}


$(document).on('click','.accordion .accordion__item .accordion__header',function() {
	toggleAccordion($(this).parents('.accordion__item'));
});